import SlimSelect from 'slim-select';
const form = document.getElementById('form-filter');
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export default {
	init() {
		console.log('init form-filter');
		console.log(queryString);

		const select1 = new SlimSelect({
			select: '#select1',
			placeholder: lang == 'hu' ? 'Nincs kiválasztva szűrési feltétel.' : 'No filter by service',
			searchPlaceholder: 'Keresés...',
			searchFocus: false,
			deselectLabel: '&times;'
		});

		const select2 = new SlimSelect({
			select: '#select2',
			placeholder: lang == 'hu' ? 'Nincs kiválasztva szűrési feltétel.' : 'No filter by category',
			searchPlaceholder: 'Keresés...',
			searchFocus: false,
			deselectLabel: '&times;'
		});

		const nameFilter = document.getElementById('name-filter');
		
		if (queryString) {
			const param1 = urlParams.get('select1[]').split(',');
			const param2 = urlParams.get('select2[]').split(',');
			const param3 = urlParams.get('name');
			select1.set([...param1]);
			select2.set([...param2]);
			nameFilter.value = param3;
		}

		form.addEventListener('submit', e => {
			e.preventDefault();
			console.log(select1.selected(), select2.selected());
			location.href = `${location.pathname}?select1[]=${select1.selected()}&select2[]=${select2.selected()}&name=${nameFilter.value}`;
		});
	}
}
